import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { BaseToast } from './BaseToast.tsx';

import {
  notificationContainerStyles,
  notificationIconContainerStyle,
  notificationImgContainerStyles,
  notificationImgStyles,
  notificationsHeadlineStyle,
  notificationSubtextStyle,
  notificationTextContainerStyle
} from '@/components/Toast/components/styles';
import CloseButton from '@/components/Toast/components/CloseButton.tsx';
import { Image } from '@/components/common/Image/Image.tsx';
import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';
import UIConfig from '@/UIConfig.ts';

export const SentGiftSuccessToast = ({
  name,
  photoUrl
}: {
  name: string;
  photoUrl?: string;
}) => {
  const { t } = useTranslation();

  return (
    <BaseToast toastKey="sent-react-success-toast" role="notification">
      <div style={notificationContainerStyles}>
        <div style={notificationImgContainerStyles}>
          <Image
            style={notificationImgStyles}
            src={photoUrl}
            alt="Sent Reaction Notification"
          />
          <FireReactionShape
            width={16}
            height={16}
            fillColor="#ffffff"
            style={{
              position: 'absolute',
              bottom: '-4px',
              right: '-4px',
              background: UIConfig.Colors.PrimaryGradient,
              borderRadius: '50%',
              padding: '4px'
            }}
          />
        </div>
        <div style={notificationTextContainerStyle}>
          <div style={notificationsHeadlineStyle}>
            {t('toast.gift_sent_msg')}
          </div>
          <p style={notificationSubtextStyle}>
            {t('toast.gift_sent_msg_subtitle', {
              name: name
            })}
          </p>
        </div>
        <div style={notificationIconContainerStyle}>
          <CloseButton handleClose={() => toast.dismiss()} />
        </div>
      </div>
    </BaseToast>
  );
};
